import React from 'react';
import { Slide } from 'components/UI/V2/Carousel/Slide';

const VIDEO_THUMBNAIL = '/images/sliders/placeholder-video.png';
const VIDEO_URL = 'https://www.loom.com/share/placeholder';
const VIDEO_TITLE = 'How to add a service?';
const VIDEO_DURATION = '2:40';

const InfoBox = ({ text }: { text: React.ReactNode }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            border: '2px solid #BCB8AE',
            borderRadius: 12,
            padding: '10px 14px',
            marginTop: 16
        }}
    >
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            style={{ flexShrink: 0, marginTop: 2 }}
        >
            <circle
                cx="8"
                cy="8"
                r="8"
                fill="#92B4A7"
            />
            <text
                x="8"
                y="12"
                textAnchor="middle"
                fill="#fff"
                fontSize="10"
                fontWeight="bold"
                fontFamily="serif"
            >
                i
            </text>
        </svg>
        <span style={{ fontSize: 14, lineHeight: 1.5, color: '#444' }}>{text}</span>
    </div>
);

const Slide1Description = () => (
    <p style={{ fontSize: 16, lineHeight: 1.6, margin: 0 }}>
        Start by naming your daycare services—use clear titles like Daycare – Half Day or Daycare – Full Day, and
        include a short, engaging description. These will be visible to clients if online booking is enabled.
    </p>
);

const Slide2Description = () => (
    <div>
        <p style={{ fontSize: 16, lineHeight: 1.6, margin: '0 0 0' }}>
            If you turn on online booking for daycare, pick at least one room or space—this sets the availability
            clients will see online.
        </p>
        <InfoBox
            text={
                <>
                    Head to Settings →{' '}
                    <a
                        href="/business_settings/info/rooms"
                        style={{ color: '#5E8677' }}
                    >
                        Rooms &amp; Spaces
                    </a>{' '}
                    to set capacity rules for each room or space.
                </>
            }
        />
    </div>
);

export const getDaycareSlides = (): Slide[] => [
    {
        id: 1,
        stepNumber: 1,
        title: 'Add your daycare services.',
        description: <Slide1Description />,
        image: '/images/sliders/daycare/slider-daycare-1.png',
        videoThumbnail: VIDEO_THUMBNAIL,
        videoTitle: VIDEO_TITLE,
        videoDuration: VIDEO_DURATION,
        videoUrl: VIDEO_URL,
        videoMarginTop: '24px'
    },
    {
        id: 2,
        stepNumber: 2,
        title: 'Select a room or space',
        description: <Slide2Description />,
        image: '/images/sliders/daycare/slider-daycare-2.png',
        videoThumbnail: VIDEO_THUMBNAIL,
        videoTitle: VIDEO_TITLE,
        videoDuration: VIDEO_DURATION,
        videoUrl: VIDEO_URL,
        videoMarginTop: '24px'
    }
];
